// Exact copy of app/title.component.ts except import UserService from shared
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../../core/services/http.service';
import { AuthService } from '../../../../core/services/auth.service';
import { QRCodeService } from '../../../services/QRCode.service';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../../../core/services/preferences.service';
import { NzModalService, NzLocaleService, zhCN, enUS, zhTW } from 'ng-zorro-antd';
import { LOCATION_INITIALIZED } from '@angular/common';


@Component({
    selector: 'app-head-top',
    templateUrl: './headTop.component.html',
    styleUrls: ['./headTop.component.css']
})
export class HeadTopComponent implements OnInit {
    isLogin: Boolean = false;
    nickName = '';
    userId = '';
    photoUrl = '';
    userInfo: any = {};
    QRCodeURL: string;


    currentLang;
    currentLangLabel;

    initCurrentLang(value) {
        this.currentLang = value;
        this.currentLangLabel = this.lang_options.filter(x => x.value == this.currentLang)[0].label;
        if (value === 'zh-CN') {
            this._localeService.setLocale(zhCN);
        } else if (value === 'en-US') {
            this._localeService.setLocale(enUS);
        } else if (value === 'vi') {
            this._localeService.setLocale(zhCN);
        } else {
            this._localeService.setLocale(zhTW);
        }
        this.translate.use(value);
    }

    setCurrentLang(value) {
        this.auth.checkLanguage({
            lang: value
        }).toPromise()
            .then(data => {
                this.preferences.set('lang', value, true);
                window.location.reload();
            }, err => {
                this.preferences.set('lang', value, true);
                window.location.reload();
            });
    }

    lang_options = [
        { label: '简体中文', value: 'zh-CN' },
        { label: '繁體中文', value: 'zh-TW' },
        { label: 'English', value: 'en-US' },
        { label: 'Tiếng Việt', value: 'vi' }
    ];

    constructor(
        private http: HttpService,
        public auth: AuthService,
        private router: Router,
        private QRCode: QRCodeService,
        private translate: TranslateService,
        private preferences: PreferencesService,
        private _localeService: NzLocaleService
    ) {
        const userInfo = sessionStorage.getItem('userInfo');
        if (userInfo !== null) {
            try {
                this.userInfo = JSON.parse(userInfo);
            } catch (err) { }
        }
    }

    ngOnInit() {
        const token: string = sessionStorage.getItem('token') || '';
        if (token.length !== 0) {
            this.isLogin = true;
            this.nickName = this.userInfo.name;
            this.userId = this.userInfo.loginName;
            this.photoUrl = this.userInfo.photo;
            this.getQRCode();
        }

        this.preferences.get('lang', true).then((value) => {
            this.initCurrentLang(value || 'zh-CN');
        });
    }

    getQRCode() {
        this.QRCode.getQRcode().subscribe(data => {
            this.QRCodeURL = data;
        });
    }

    logout() {
        this.auth.logout();
    }

    jump2Msg() {
        this.router.navigate(['/message' || ''], {
            queryParams: { 'date': new Date().getTime() }
        });
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/headTop/headTop.component.ts